import { Search, X } from "lucide-react";

export function SearchBar({ value, onChange, mobileInset = false }) {
  return (
    <div className={`${mobileInset ? "pl-14 pr-14 md:pr-4 xl:px-4" : "px-4"} py-3 border-b border-[#E5E5E5] dark:border-zinc-800`}>
      <div className="flex items-center gap-2 bg-[#F5F5F5] dark:bg-zinc-900 px-3 py-2">
        <Search className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" strokeWidth={1.5} />
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Søg i nyheder..."
          className="bg-transparent text-xs font-mono w-full outline-none focus:outline-none placeholder-gray-400 dark:placeholder-gray-400 text-[#0A0A0A] dark:text-zinc-100"
          data-testid="search-input"
          aria-label="Søg i nyheder"
        />
        {value && (
          <button
            onClick={() => onChange("")}
            className="text-gray-400 hover:text-[#0A0A0A] dark:hover:text-zinc-50 rounded-sm focus:outline-none"
            data-testid="search-clear"
            aria-label="Ryd søgning"
          >
            <X className="w-3 h-3" strokeWidth={1.5} />
          </button>
        )}
      </div>
    </div>
  );
}
